import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import PoweredBy from '../../ui/PoweredBy';

const Layout = ({ children }) => (
  <>
    <Header />
    {children}
    <PoweredBy fixed />
  </>
);

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
